<template>
  <div v-if="nomenclature">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ getTitle }} </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component
      v-if="error"
      :error="error"
      :messages="messages"
      :withEmplyFields="true"
      :champsVide="champsVide"
      :messagesChampsVide="messagesChampsVide"
      @close="error = $event"
      class="mgt-20px"
      title="general.problemOccurred"/>
    <div class="columns is-multiline mgt-20px">
      <b-field
        :label="$t('addEditNomenclatureType.information.libelle')"
        class="obligatoire column is-6 mgb-0">
        <b-input v-model="nomenclature.libelle"></b-input>
      </b-field>
      <b-field
        :label="$t('addEditNomenclatureType.information.reference')"
        class="obligatoire column is-6 mgb-0">
        <b-select v-model="nomenclature.reference" expanded>
          <option
            v-for="item in listeReferenceType"
            :key="item.code"
            :value="item.code">
            {{ $t(item.libelle) }}
          </option>
        </b-select>
      </b-field>
      <b-field class="column is-12 mgb-0">
        <qd-json-edit
          :schema.sync="nomenclature.schema"/>
      </b-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { get, update, create } from '@/api/nomenclatureType';
import genererNomenclatureType from '@/services/parametrage/generation/genererNomenclatureType';
import translator from '@/services/parametrage/translator/translatorNomenclatureType';
import validation, { removeDuplicateMsgError } from '@/services/validation/validation';
import validationNomenclature from '@/services/parametrage/validation/validationNomenclatureType';
import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import { LISTE_REFERENCE_TYPE } from '@/configuration/parametrage/nomenclatureTypeConf';
import qdJsonEdit from '@/components/parametrage/nomenclature/qdJsonEdit';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'AjoutModificationNomenclatureType',
  data() {
    return {
      nomenclature: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      listeReferenceType: LISTE_REFERENCE_TYPE,
      error: false,
      libelle: '',
    };
  },
  components: {
    errorMsgComponent,
    breadcrumb,
    qdJsonEdit,
  },
  computed: {
    getTitle() {
      if (this.$route.params.id) return this.$t('addEditNomenclatureType.titleEdit', { libelle: this.libelle });
      return this.$t('addEditNomenclatureType.titleAdd');
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('general.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('addEditNomenclatureType.liste'), route: { name: 'l.parametrage.nomenclature_type' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const item = cloneDeep(this.nomenclature);
        item.schema = JSON.stringify(item.schema);
        if (this.nomenclature.id) {
          await update(item);
          messageSuccess(this.$i18n.t('addEditNomenclatureType.success.edit'));
        } else {
          await create(item);
          messageSuccess(this.$i18n.t('addEditNomenclatureType.success.add'));
        }
        await this.loadParametreForce(typesParametres.PARAMETRES_KEYS.nomenclatureType);
        await this.$router.push({ name: 'l.parametrage.nomenclature_type' });
      } catch (e) {
        if (e?.response?.data?.error?.validationErrors) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translator);
          validationNomenclature(e.response, this.messages);
          this.messages = removeDuplicateMsgError(this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        const nomenclature = (await get(this.$route.params.id)).data.result;
        nomenclature.schema = JSON.parse(nomenclature.schema);
        this.nomenclature = nomenclature;
        this.libelle = cloneDeep(this.nomenclature.libelle);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nomenclature.libelle }));
      } else {
        this.nomenclature = genererNomenclatureType();
        this.setInformationPage(this.$t('pageParametrage.nomenclatureType.creation'));
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
